import { computed, toValue } from "vue";
import { useBuiltComponentStore } from "..";
import { useBuiltComponents } from "./useBuiltComponents";
export const useCampaignBuiltComponents = (campaignId) => {
    const { primer } = useBuiltComponents();
    const builtComponentStore = useBuiltComponentStore();
    const builtComponents = computed(() => {
        const campaignIdValue = toValue(campaignId);
        if (!campaignIdValue) {
            return [];
        }
        return builtComponentStore.getCampaignBuiltComponents(campaignIdValue);
    });
    return {
        primer,
        builtComponents,
    };
};
